import React, { useEffect } from 'react';
import _ from 'lodash';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import OilThumb from '../../OilThumb';
import OilBaseInfomation from '../../OilBaseInfomation';
import OilVolumesService from '../../OilVolumesService';
import localesReplacement from '../../../utils/localesReplacement';
import {
  IComponentVolumes,
  IProd,
  IServiceIntervals,
  IState,
  ProductCategory,
  Replacement
} from '../../../interface';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import actions from '../../../redux/actions';
import { PageType } from '../../../interface/emnu';


const cx = classnames.bind(style);

interface IProps {
  dataList: IProd;
  serviceIntervals: IServiceIntervals[];
  vehicleComponentVolumes: IComponentVolumes[];
  setVehicleComponentVolumes: (value: IComponentVolumes[]) => void;
  setServiceIntervals: (value: IServiceIntervals[]) => void;
  productCategories: ProductCategory[];
  replacements: Replacement;
  notes?: string[]
}

export const Information = (props: IProps) => {
  const {
    dataList,
    serviceIntervals,
    vehicleComponentVolumes,
    setServiceIntervals,
    setVehicleComponentVolumes,
    productCategories,
    replacements,
    notes
  } = props;
  const window: any = globalThis;
  window.dataLayer = window.dataLayer || [];
  useEffect(() => {
    window.dataLayer.push({
      'event': 'productView',
      'pageType': PageType.ProductPage,
      'oilName': dataList?.name,
      'countryCode': localStorage.getItem('countryCode')
    })
    return () => {
      setServiceIntervals([]);
      setVehicleComponentVolumes([]);
    };
  }, []);
  const pdsDataLayer = () => {
    window.dataLayer.push({
      'event': 'dataSheetClick',
      'pageType': PageType.ProductPage,
      'buttonName': 'dataSheets',
      'oilName': dataList?.name,
      'countryCode': localStorage.getItem('countryCode')
    });
  }
  const msdsDataLayer = () => {
    window.dataLayer.push({
      'event': 'materialSafetyDataSheetClick',
      'pageType': PageType.ProductPage,
      'buttonName': 'materialSafetyDataSheets',
      'oilName': dataList?.name,
      'countryCode': localStorage.getItem('countryCode')
    });
  }
  return dataList ? (
    <div className={cx('section')}>
      <div className={cx('sider')}>
        <OilThumb
          withoutMoreLink={true}
          products={dataList}
          Recommendation="product page"
          dataList={{
            id: dataList.id,
            packartUrl: dataList.packartUrl ? [dataList.packartUrl[0]] : [],
            productCategoryId: dataList.productCategoryId,
            links: dataList.links,
          }}
        />
      </div>
      <div className={cx('content')}>
        <OilBaseInfomation
          withoutMoreLink={true}
          dataList={dataList}
          productCategories={productCategories}
        />
        {!_.isEmpty(vehicleComponentVolumes) && (
          <OilVolumesService
            notes={notes}
            withoutMoreLink={true}
            dataList={{ ...dataList, serviceIntervals }}
            componentVolumes={vehicleComponentVolumes}
          />
        )}
        <div className={style['links']}>
          {dataList.msdsUrl && (
            <a
              onClick={msdsDataLayer}
              href={dataList.msdsUrl}
              target='_blank'
              rel='noreferrer'
              className='secondary-button'
              role='button'
            >
              {localesReplacement(replacements, 'Material Safety Data Sheets')}
            </a>
          )}
          {dataList.pdsUrl && (
            <a
              onClick={pdsDataLayer}
              href={dataList.pdsUrl}
              target='_blank'
              rel='noreferrer'
              className='secondary-button'
              role='button'
            >
              {localesReplacement(replacements, 'Data Sheets')}
            </a>
          )}
        </div>
      </div>
    </div>
  ) : null;
};

const mapStateToProps = (state: IState) => ({
  serviceIntervals: state.serviceIntervals,
  vehicleComponentVolumes: state.vehicleComponentVolumes,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setServiceIntervals: (value: IServiceIntervals[]) =>
    dispatch(actions.setServiceIntervals(value)),
  setVehicleComponentVolumes: (value: IComponentVolumes[]) =>
    dispatch(actions.setVehicleComponentVolumes(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Information);
